<template>
    <div class="edit-assignments apprentice-simple-card">
        <design-2021-assignment-edit-sub-assignment-header-component
            :sub-assignment-in="subAssignmentIn"
            :can-edit-portfolio="canEditPortfolio"
            :group-in="groupIn"
            :assignment-in="assignmentIn">
        </design-2021-assignment-edit-sub-assignment-header-component>

        <draggable
            class="sub-assignments-pages draggable-pages"
            group="subassignmentpages"
            :list="pages"
            :disabled="!canEditPortfolio"
            handle=".sub-assignment-edit-page-drag-handle"
            @change="orderChanged()"
            ghost-class="drag-ghost">
            <design-2021-assignment-edit-page-component
                v-for="page in pages"
                :page-in="page"
                :can-edit-portfolio="canEditPortfolio"
                :profile-categories-in="profileCategoriesIn"
                :group-id="groupIn ? groupIn.id : null"
                :key="page.id"
                @page-removed="orderChanged($event)">
            </design-2021-assignment-edit-page-component>
        </draggable>

        <div
            class="new-page-container"
            v-if="canEditPortfolio">
            <b-button
                class="btn-add"
                v-b-modal="'assignment-add-page'"
                variant="primary">
                {{ $t('assignment.add_page') }}
            </b-button>

            <design-2021-assignment-add-page-modal
                :ords="true"
                :sub-assignment-in="subAssignmentIn">
            </design-2021-assignment-add-page-modal>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import { ords } from '../../../../app';

export default {
    name: 'design-2021-assignment-edit-sub-assignment-component',
    components: { draggable },
    props: ['subAssignmentIn', 'groupIn', 'assignmentIn', 'profileCategoriesIn', 'canEditPortfolio'],
    data() {
        return {
            pages: this.subAssignmentIn.pages,
        };
    },
    watch: {
        subAssignmentIn: function (subAssignmentIn) {
            this.pages = subAssignmentIn.pages;
        },
    },
    methods: {
        orderChanged(id) {
            let x = 1;
            let blocks = [];

            for (const page of this.pages) {
                if (id && id === page.id) {
                    continue;
                }

                blocks.push({
                    id: page.id,
                    order: x,
                });
                x++;
            }

            const data = {
                sub_assignment_id: this.subAssignmentIn.id,
                blocks: blocks,
            };

            ords.hold();
            this.axios.post(this.routes.assignmentPageOrder(), data).then(
                (response) => {
                    for (const block of blocks) {
                        ords.use('assignmentPage').update({ order: block.order }, block.id);
                    }
                    ords.continue();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.new-page-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');

    .btn {
        width: 185px;
    }
}
</style>
